module.exports = __webpack_public_path__ + "img/ser.a206f7bf.svg";